import { StyledElement, defineElement } from '@webtides/element-js';
import style from './sticky.css';

// Copied from @webtides/element-library
export default class Sticky extends StyledElement {
    lastScrollTop = 0;
    resizeObserver = undefined;

    constructor() {
        super({ styles: [style] });
    }

    properties() {
        return {
            forceDown: false,
        };
    }

    connected() {
        this.calcCSSProperties();
        try {
            this.resizeObserver = new ResizeObserver(() => {
                this.calcCSSProperties();
            });
            this.resizeObserver.observe(this);
        } catch (e) {}
    }

    disconnected() {
        if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    events() {
        return {
            document: {
                scroll: () => this.hasScrolled(window.scrollY),
            },
            window: {
                load: () => {
                    //wait for window to be loaded - otherwise width won't respect the scrollbar
                    this.calcCSSProperties();
                },
                resize: () => {
                    this.calcCSSProperties();
                },
            },
        };
    }

    calcCSSProperties() {
        this.style.setProperty('--sticky-height', this.offsetHeight + 'px');
    }

    hasScrolled(scrollY) {
        if (scrollY > this.offsetHeight && scrollY > 0) {
            this.classList.add('is-sticky');
        } else {
            this.classList.remove('is-sticky');
        }

        if (scrollY > this.lastScrollTop && scrollY > this.offsetHeight) {
            // Scroll Down
            this.classList.remove('is-down');
            this.classList.add('is-up');
        } else {
            // Scroll Up
            if (scrollY < this.lastScrollTop) {
                this.classList.remove('is-up');
                this.classList.add('is-down');
            }
        }

        this.lastScrollTop = scrollY;
    }
}

defineElement('mb-sticky', Sticky);
